import React, { Component } from 'react'
import ArrowButton from '../arrowButton'

// Styles
import './tableExpand.scss'

class TableExpand extends Component {
  constructor (props) {
    super(props)

    this.state = {
      expand: props.expand || false
    }

    this.onClick = this.onClick.bind(this)
    this.updateExpand = this.updateExpand.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.expand !== undefined && nextProps.expand !== this.state.expand) {
      this.updateExpand(nextProps.expand)
    }
  }

  onClick () {
    console.log('tableExpand onClick', this.props.expand, !this.state.expand)

    if (this.props.onClick !== null) {
      this.props.onClick(!this.state.expand)
    } else {
      this.updateExpand(!this.state.expand)
    }
  }

  updateExpand (expand) {
    this.setState({
      expand: typeof expand === 'boolean' ? expand : !this.state.expand
    })
  }

  mapHeader (tHeader) {
    const thChildren = React.Children.toArray(tHeader.props.children)
    const childrenCount = thChildren.length

    let arrowDir = this.state.expand ? 'down' : 'right'
    // Pass expand indicator to the header
    const newChildren = [
      ...thChildren,
      <div className='element-table-expand__indicator' key='indicator'>
        <ArrowButton size='m' dir={arrowDir} />
      </div>
    ]

    // Add extra column to the headers cols prop
    let cols = tHeader.props.cols
    if (cols.length === 0) {
      cols = new Array(childrenCount).fill(1)
    }

    let newCols
    if (typeof cols === 'string') {
      newCols = cols += ' min-content'
    } else {
      newCols = [
        ...cols,
        'min-content'
      ]
    }

    return React.cloneElement(tHeader, {
      children: newChildren,
      cols: newCols,
      expand: this.state.expand
    })
  }

  render () {
    const { children } = this.props

    let header = null
    let rows = null
    if (children[0].type.displayName === 'TableHeader') {
      const [ tHeader, ...tRows ] = children

      header = this.mapHeader(tHeader)
      rows = tRows
    }

    if (header === null) {
      console.error('TableExpand must include a TableHeader')
    }

    const contentClass = this.state.expand ? ' element-table-expand__content--expand' : ''

    return (
      <div className='element-table-expand'>
        <div onClick={this.onClick}>
          {header}
        </div>

        <div className={'element-table-expand__content' + contentClass}>
          {rows}
        </div>
      </div>
    )
  }
}

TableExpand.defaultProps = {
  onClick: null,
  children: []
}

export default TableExpand



// WEBPACK FOOTER //
// ./src/app/shared/elements/tableExpand/index.js